import React, { useEffect } from "react";
import { Container, Tab, Tabs, Box, Grid } from "@mui/material";
import Header from "./Header";
import BottomNav from "./BottomNav";
import Chats from "./Chats";
import News from "./News";
import { isLoggedIn } from "../session";
import { useNavigate } from "react-router-dom"

const Home = () => {
  const [value, setValue] = React.useState(0); // Inicializa en 0 para "Chats" o 1 para "Products"

  let navigate = useNavigate();
  useEffect(() => {
    if (!isLoggedIn()) {
      navigate("/login");
    }
  }, [navigate]);

  return (
    <>
      <Header />
      <Container>
        <Box sx={{ display: "flex", width: "100%", position: "fixed", zIndex: 10, top: 70, left: 0, backgroundColor: "white", borderBottom: 1, borderColor: "divider" }}>
          <Grid container justifyContent="center">
            <Tabs
              value={value}
              onChange={(event, newValue) => setValue(newValue)}
              variant="fullWidth"
              centered
              sx={{ width: "100%" }}
            >
              <Tab label="Chats" sx={{ flex: 1,backgroundColor: "white" }} />
              <Tab label="Noticias" sx={{ flex: 1,backgroundColor: "white" }} />
            </Tabs>
          </Grid>
        </Box>
        {value === 0 && <Chats />}
        {value === 1 && <News />}
      </Container>
      <BottomNav />
    </>
  );
};

export default Home;
